/**
 * Leitura da situação vinda de outro sistema.
 *
 * eSUS e SISREG têm vocabulários próprios ("Agendamento Confirmado" contra
 * "AGENDAMENTO / CONFIRMADO / EXECUTANTE"), e nenhum dos dois é o status do
 * KAVI. A cor sai de palavras-chave, e o que não casa fica neutro — melhor
 * sem cor do que com a cor errada.
 */

export type TomSituacao = 'neutro' | 'sucesso' | 'alerta' | 'perigo';

const REGRAS: [RegExp, TomSituacao][] = [
  [/NEGAD|DEVOLVID|CANCELAD|FALTA|RECUSAD|EXPIRAD/, 'perigo'],
  [/PENDEN|ESPERA|REENVIAD|REGULACAO|ANALISE|SOLICITAD/, 'alerta'],
  [/CONFIRMAD|AGENDAD|AUTORIZAD|ATENDID|EXECUTAD|APROVAD|MARCAD/, 'sucesso'],
];

function normalizar(texto: string): string {
  return texto.normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase();
}

export function tomDaSituacao(situacao: string | null): TomSituacao {
  if (!situacao) return 'neutro';
  const texto = normalizar(situacao);
  return REGRAS.find(([padrao]) => padrao.test(texto))?.[1] ?? 'neutro';
}

/** `AGENDAMENTO / CONFIRMADO / EXECUTANTE` → `Agendamento · confirmado · executante`. */
export function rotuloDaSituacao(situacao: string | null): string {
  if (!situacao) return '—';
  const partes = situacao
    .split('/')
    .map((parte) => parte.trim().toLowerCase())
    .filter(Boolean);
  const texto = partes.join(' · ');
  return texto.charAt(0).toUpperCase() + texto.slice(1);
}
